import * as React from 'react';
import { Link } from 'react-router-dom';
import { ICultureInfo } from '../abstraction';

interface IGetActiveCulture {
    getActiveCultures: () => ICultureInfo[]
}

interface IProps {
    onLangChanged: (lang: string) => void;
    cultureProvider: IGetActiveCulture;
}

// Panel affichant les drapeaux repr�sentant les cultures disponibles
export class KLangPanel extends React.Component<IProps> {
    public constructor(props: any) {
        super(props);
    }

    onClick(lang: string) {
        if (this.props.onLangChanged) this.props.onLangChanged(lang);
    }

    render() {
        return (
            <div className="KLangPanel">
                {  
                    this.props.cultureProvider.getActiveCultures().map((x,i) =>
                        <Link key={i} to="#" color="secondary" onClick={this.onClick.bind(this, x.code)}><img src={x.imgdata} alt={x.code}/></Link>
                    )
                }
            </div>
        );
    }
}
